<mat-toolbar>
  <mat-toolbar-row class="flex flex-row gap-2">
    <img class="h-10" src="/images/shareview-icon.png" alt="ShareView logo" />
    <span>Remote Clinician Console</span>
    <span class="flex-1"></span>
    <button matButton (click)="logout.emit()">Logout</button>
  </mat-toolbar-row>
</mat-toolbar>
